/* @jsx h */
import { useCustomer } from "@app/vue/providers/Auth";
import { useMenu } from "@app/vue/providers/Menu";
import logoURL from "@lemmonhq/assets/images/branding/dark-favico.svg?url";
import { defineComponent, h, ref } from "vue";
import { RouterLink, useRoute } from "vue-router";
import { RealtimeButton } from "./RealtimeButton";
import { CartServiceMethodSelector } from "./CartServiceMethodSelector";
import { CustomerLanguageSelector } from "../../../../components/CustomerLanguageSelector";

export const ShopHeaderTop = defineComponent({
  name: "ShopHeaderTop",
  setup(props) {
    const { shop, cart, groupOrder } = useMenu();
    // cart.cart.serviceMethod
    const auth = useCustomer();
    const slug = shop.value.slug;
    const route = useRoute();
    const showInfoModal = ref(false);
    const { customer } = useCustomer();
    return () => {
      return (
        <div
          data-a={77}
          class="flex justify-between items-center py-2 px-2 md:px-4 sticky top-0 left-0 right-0 bg-base-100 border-b"
        >
          <div class="flex justify-center items-center">
            <RouterLink
              class="hidden bg-base-300 border border-base-300 rounded flex justify-center items-center mr-2"
              to={
                groupOrder.value
                  ? groupOrder.value.table
                    ? `/restaurant/${slug}/group-order/${groupOrder.value.id}`
                    : `/restaurant/${slug}`
                  : "/"
              }
            >
              <img class="" src={logoURL} width="40px" />
            </RouterLink>
            <RouterLink
              to={
                groupOrder.value
                  ? groupOrder.value.table
                    ? `/restaurant/${slug}/group-order/${groupOrder.value.id}`
                    : `/restaurant/${slug}`
                  : "/"
              }
              class="text-accent text-2xl"
            >
              {shop.value.name}
            </RouterLink>{" "}
          </div>
          <div class="flex items-center gap-1 md:gap-2">
            {groupOrder.value?.status === "completed" ? null : groupOrder.value
                ?.type === "single" ? null : groupOrder.value?.table_id ? (
              <div class="flex-1 text-2xl flex gap-2 flex items-center ">
                <RealtimeButton />
              </div>
            ) : (
              <CartServiceMethodSelector
                allowedMethods={cart.cart.allowedOrderServiceMethods || []}
                selectedMethod={cart.cart.serviceMethod}
                onMethodChange={(method) => {
                  cart.cart.serviceMethod = method;
                }}
              />
            )}

            <div class="flex py-0 gap-1 flex-1 justify-end hidden">
              <div class="flex items-center space-x-2 text-sm">
                <button
                  onClick={() => (showInfoModal.value = true)}
                  class="flex items-center justify-center"
                >
                  <span class="material-symbols-outlined badge badge-success text-2xl py-4">
                    info
                  </span>
                </button>
              </div>
            </div>
            {customer.value?.anon ? (
              <>
                <div
                  class="btn btn-primary hidden text-1xl"
                  onClick={() => {
                    auth.showAuthDialog();
                  }}
                >
                  <span class="material-symbols-outlined  text-2xl">lock</span>
                  Auth
                </div>
              </>
            ) : null}

            <RouterLink
              class="hidden text-2xl"
              to={`/restaurant/${slug}/reserve`}
            >
              <span class="material-symbols-outlined  text-4xl">
                calendar_month
              </span>
            </RouterLink>
            {groupOrder.value?.table_id ? null : (
              <>
                <CustomerLanguageSelector />
                <RouterLink
                  class={
                    route.path.startsWith(`/restaurant/${slug}/user/me`)
                      ? "text-accent"
                      : "text-accent/50"
                  }
                  to={`/restaurant/${slug}/account/profile`}
                >
                  <span class="material-symbols-outlined  text-4xl">face</span>
                </RouterLink>
              </>
            )}
          </div>
        </div>
      );
    };
  },
});
